import { createRoot } from "react-dom/client";
import "@redgifscom/ui-react/styles/variable.css";
import "@redgifscom/ui-react/styles/fonts.css";
import "@redgifscom/ui-react/styles/typography.css";
import { reportLCP } from "@/common/utils/reportLCP";
import { startWebVitals } from "@/common/utils/webVitals";
import { AppContainer } from "components/app/AppContainer";

const root = createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<AppContainer />);

reportLCP();
startWebVitals();
